import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Paper, Typography } from "@mui/material";
import { DataGridPro } from "@mui/x-data-grid-pro";
import { useEffect, useRef, useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { formatCurrency } from "./utils";
import { useNavigate } from "react-router-dom";
import html2canvas from 'html2canvas';
import { useSelector } from "react-redux";


const SalesPersonReport = (props) => {
    const salesPersonData = props.salesPersonData;
    const selectedSalesPerson = useSelector((state) => state.cart.selectedSalesPerson);
    const salesPeople = useSelector((state) => state.cart.salesPeople);
    const colors = props.colors;
    const selectedToDate = props.selectedToDate
    const selectedFromDate = props.selectedFromDate
    const [accordionExpanded, setAccordionExpanded] = useState(false);
    const [downloadingScreenshot, setDownloadingScreenshot] = useState(false);
    const [sortModel, setSortModel] = useState([
        {
            field: 'quantity',
            sort: 'desc',
        },
    ]);
    const navigate = useNavigate();
    const ToCaptureRef = useRef(null) // ref

    const handleQuotationItemDetailRouting = (event) => {
        navigate(`/quotation/${event.id}/${event.row?.get('quotationType')}/${event.row?.get('createdBy').id}`)
    };
    useEffect(() => {
        // Component mount effect for salesPersonData
    }, [salesPersonData]);

    const columns = [
        {
            field: "createdAt",
            headerName: "Created At",
            width: 150,
            headerAlign: "center",
            align: "center", // Aligns content to the center
            valueGetter: (params) => `${params?.row.get('createdAt') || ""}`,
        },
        {
            field: "quotationNumber",
            headerName: "Quotation No.",
            width: 120,
            headerAlign: "center",
            align: "center", // Aligns content to the center
            valueGetter: (params) => `${params?.row.get('quotationNumber') || ""}`,
        },
        {
            field: "quotationStatus",
            headerName: "Status",
            width: 120,
            headerAlign: "center",
            align: "center", // Aligns content to the center
            valueGetter: (params) => `${params?.row.get('quotationStatus') || ""}`,
        },
        {
            field: "quotationType",
            headerName: "Type",
            width: 120,
            headerAlign: "center",
            align: "center", // Aligns content to the center
            valueGetter: (params) => `${params?.row.get('quotationType') || ""}`,
        },
        {
            field: "client",
            headerName: "Client",
            width: 180,
            headerAlign: "center",
            align: "center", // Aligns content to the center
            valueGetter: (params) => `${params?.row.get('selectedClient')?.data?.companyName || ""}`,
        },
        {
            field: "sections",
            headerName: "Sections",
            width: 90,
            headerAlign: "center",
            align: "center", // Aligns content to the center
            valueGetter: (params) => `${params?.row.get('sections').length || ""}`,
        },
        {
            field: "discount",
            headerName: "Discount%",
            width: 120,
            headerAlign: "center",
            align: "center", // Aligns content to the center
            valueGetter: (params) => `${params?.row.get('sections').map((sec) => " " + (sec.discountPercentage ?? "0")) || "0"}`,
        },
        {
            field: "margin",
            headerName: "Margin%",
            width: 120,
            headerAlign: "center",
            align: "center", // Aligns content to the center
            valueGetter: (params) => `${params?.row.get('sections').map((sec) => " " + (sec.marginPercentage ?? "0")) || "0"}`,
        },
        {
            field: "netTotal",
            headerName: "Net Total",
            width: 120,
            headerAlign: "center",
            align: "center", // Aligns content to the center
            valueGetter: (params) => `$${formatCurrency(params?.row.get('totalPrice')) || ""}`,
        },
    ];

    useEffect(() => {
        // Function to hide the MUI X license warning
        const hideMuiXWarning = () => {
            // Try to find the element by its text content
            const warningElement = Array.from(document.body.getElementsByTagName('*'))
                .find(element => element.textContent === 'MUI X Missing license key');

            // If the element is found, hide it
            if (warningElement) {
                warningElement.style.display = 'none';
            }
        };

        // Call the function to hide the warning
        hideMuiXWarning();

        // Optional: Set up a MutationObserver to handle dynamically added elements
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                if (mutation.addedNodes.length) {
                    hideMuiXWarning();
                }
            });
        });

        observer.observe(document.body, { childList: true, subtree: true });

        // Cleanup function
        return () => {
            observer.disconnect();
        };
    }, []); // Empty dependency array means this effect runs once on mount

    const captureScreenshot = () => {
        var canvasPromise = html2canvas(ToCaptureRef.current, {
            useCORS: true
        });
        setDownloadingScreenshot(true);
        canvasPromise.then((canvas) => {
            var dataURL = canvas.toDataURL('image/png');

            // Create a formatted date string
            const formattedDateFrom = new Date(selectedFromDate).toLocaleDateString();
            const formattedDateTill = new Date(selectedToDate).toLocaleDateString();

            // Create the filename
            const filename = `${salesPersonName.get('firstName')}_${salesPersonName.get('lastName')}_${formattedDateFrom}_${formattedDateTill}.png`;

            // Create an image element from the data URL
            var img = new Image();
            img.src = dataURL;

            // Create a link element
            var a = document.createElement("a");
            a.innerHTML = "DOWNLOAD";
            a.target = "_blank";
            // Set the href of the link to the data URL of the image
            a.href = img.src;
            // Set the download attribute of the link to the new filename
            a.download = filename;
            // Append the link to the page
            document.body.appendChild(a);
            // Click the link to trigger the download
            a.click();
            // Remove the link from the page
            document.body.removeChild(a);
            setDownloadingScreenshot(false);
        });
    }

    const salesPersonName = salesPeople.filter((p) => p.id === selectedSalesPerson)[0]
    // Calculate deposit quotations and amount (latest only per quotation)
    const depositQuotations = salesPersonData.reduce((arr, item) => {
        const revisions = item.get('fetchedRevisions') || [];
        // Find deposit-stage revisions
        const depositRevisions = revisions.filter(rev => rev.get('status') === "deposit");
        if (depositRevisions.length > 0) {
            // Only count the latest deposit revision
            const latestRevision = depositRevisions[depositRevisions.length - 1];
            arr.push(latestRevision);
        } else if (item.get('status') === "deposit") {
            // Only count the main if no deposit revision exists
            arr.push(item);
        }
        return arr;
    }, []);

    function getOpenStageSummary(salesPersonData) {
        let total = 0;
        let count = 0;

        salesPersonData.forEach((quotation) => {
            if (quotation.get('status') === 'open') {
                const revisions = quotation.get('fetchedRevisions') || [];
                const openRevisions = revisions.filter(rev => rev.get('status') === 'open');
                if (openRevisions.length > 0) {
                    // Only count the latest open revision
                    const latestOpenRevision = openRevisions[openRevisions.length - 1];
                    total += parseFloat(latestOpenRevision.get('totalPrice')) || 0;
                    count += 1;
                } else {
                    // No open revisions, count the main quotation
                    total += parseFloat(quotation.get('totalPrice')) || 0;
                    count += 1;
                }
            }
        });

        return { total, count };
    }
    const { total: openStageTotal, count: openStageCount } = getOpenStageSummary(salesPersonData);
    let total = 0;
    let count = 0;

    salesPersonData.forEach((quotation) => {
        if (quotation.get('status') === 'open') {
            const revisions = quotation.get('fetchedRevisions') || [];
            const openRevisions = revisions.filter(rev => rev.get('status') === 'open');
            if (openRevisions.length > 0) {
                // Only count the latest open revision
                const latestOpenRevision = openRevisions[openRevisions.length - 1];
                total += parseFloat(latestOpenRevision.get('totalPrice')) || 0;
                count += 1;
                console.log(
                    `Quotation ${quotation.get('quotationNumber')} | Using Revision: ${latestOpenRevision.get('quotationNumber')} | Amount: $${latestOpenRevision.get('totalPrice')}`
                );
            } else {
                // No open revisions, count the main quotation
                total += parseFloat(quotation.get('totalPrice')) || 0;
                count += 1;
                console.log(
                    `Quotation ${quotation.get('quotationNumber')} | Using Main Quotation | Amount: $${quotation.get('totalPrice')}`
                );
            }
        }
    });

    console.log(`Total Open Stage Amount (with latest open revisions): $${total.toFixed(2)}`);
    console.log(`Total Quotations in Open Stage (with latest open revisions): ${count}`);
    // for consoling the deposit quotatoions in 
    // console.log("depositQuotations:", depositQuotations);
    // just for consoling
    //     depositQuotations.forEach(item => {
    //     const isRevision = !!item.get('revisionNumber');
    //     const name = isRevision ? `Revision: ${item.get('revisionNumber')}` : `Quotation: ${item.get('quotationNumber')}`;
    //     const amount = item.get('totalPrice');
    //     console.log(`${name}, Amount: ${amount}`);
    // });
    const depositCount = depositQuotations.length;
    const depositAmount = depositQuotations.reduce((sum, item) => sum + (parseFloat(item.get('totalPrice')) || 0), 0);

    return (
        <>
            {salesPersonData.length > 0 && <Paper elevation={3} sx={{ mt: 5, padding: 2, borderRadius: 3, margin: 4 }}>
                <Box textAlign={'right'} mb={1}>
                    <Button
                        sx={{
                            backgroundColor: colors.blueAccent[700],
                            color: colors.grey[100],
                            fontSize: "14px",
                            fontWeight: "bold",
                            padding: "5px 20px",
                        }}
                        disabled={!accordionExpanded || downloadingScreenshot}
                        onClick={captureScreenshot}
                    >
                        Download Report
                    </Button>
                </Box>
                <Accordion ref={ToCaptureRef} id="capture" onChange={(e, expanded) => { if (expanded) { setAccordionExpanded(true) } else { setAccordionExpanded(false) } }}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1-content"
                        id="panel1a-header"
                    >
                        <Typography mr={2} variant="h4" fontWeight={'bold'} color={colors.greenAccent[400]}>{salesPersonName.get('firstName')} {salesPersonName.get('lastName')}</Typography>
                        Report Summary From {new Date(selectedFromDate).toLocaleDateString()} to {new Date(selectedToDate).toLocaleDateString()}
                    </AccordionSummary>
                    <AccordionDetails>

                        <Box display={"flex"} border={'1px solid gray'} borderRadius={2} p={1} justifyContent={'space-around'}>
                            <Typography
                                variant="h4"
                                fontWeight="600"
                                sx={{ padding: "10px 10px 10 10px" }}
                                color={colors.greenAccent[400]}
                            >
                                Total Quotations Made:
                            </Typography>
                            <Typography
                                variant="h4"
                                fontWeight="800"
                                sx={{ padding: "10px 10px 10 10px" }}
                            >
                                {salesPersonData.length}
                            </Typography>
                        </Box>

                        <Box display={"flex"} justifyContent={'space-between'} borderBottom={`1px solid ${colors.primary[600]}`} pb={1}>
                            <Box display={"flex"} justifyContent={'space-between'}>
                                <Typography
                                    variant="h4"
                                    fontWeight="600"
                                    sx={{ padding: "10px 10px 0 10px" }}
                                    color={colors.greenAccent[400]}
                                >
                                    Total Quotations in Open Stage
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontWeight="800"
                                    sx={{ padding: "10px 10px 0 10px" }}
                                >
                                    {salesPersonData.filter((data) => data.get('status') === 'open').length}
                                </Typography>
                            </Box>
                            <Box display={"flex"} justifyContent={'space-between'}>
                                <Typography
                                    variant="h4"
                                    fontWeight="600"
                                    sx={{ padding: "10px 10px 0 10px" }}
                                    color={colors.greenAccent[400]}
                                >
                                    Total Open Stage Amount
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontWeight="800"
                                    sx={{ padding: "10px 10px 0 10px" }}
                                >
                                    ${formatCurrency(openStageTotal.toFixed(2))}
                                </Typography>
                            </Box>
                        </Box>

                        <Box display={"flex"} justifyContent={'space-between'} borderBottom={`1px solid ${colors.primary[600]}`} pb={1}>
                            <Box display={"flex"} justifyContent={'space-between'}>
                                <Typography
                                    variant="h4"
                                    fontWeight="600"
                                    sx={{ padding: "10px 10px 0 10px" }}
                                    color={colors.greenAccent[400]}
                                >
                                    Total Revisions in Open Stage
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontWeight="800"
                                    sx={{ padding: "10px 10px 0 10px" }}
                                >
                                    {salesPersonData.reduce((total, item) => {
                                        const revisions = item.get('fetchedRevisions') || [];
                                        return total + revisions.filter(rev => rev.get('status') === "open").length;
                                    }, 0)}
                                </Typography>
                            </Box>
                            <Box display={"flex"} justifyContent={'space-between'}>
                                <Typography
                                    variant="h4"
                                    fontWeight="600"
                                    sx={{ padding: "10px 10px 0 10px" }}
                                    color={colors.greenAccent[400]}
                                >
                                    Total Open Stage Revision Amount
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontWeight="800"
                                    sx={{ padding: "10px 10px 0 10px" }}
                                >
                                    ${formatCurrency(salesPersonData.reduce((sum, item) => {
                                        const revisions = item.get('fetchedRevisions') || [];
                                        return sum + revisions
                                            .filter(rev => rev.get('status') === "open")
                                            .reduce((revSum, rev) => revSum + (parseFloat(rev.get('totalPrice')) || 0), 0);
                                    }, 0).toFixed(2))}
                                </Typography>
                            </Box>
                        </Box>

                        <Box display={"flex"} justifyContent={'space-between'} borderBottom={`1px solid ${colors.primary[600]}`} pb={1}>
                            <Box display={"flex"} justifyContent={'space-between'}>
                                <Typography
                                    variant="h4"
                                    fontWeight="600"
                                    sx={{ padding: "10px 10px 0 10px" }}
                                    color={colors.greenAccent[400]}
                                >
                                    Average Margin% in Open Stage
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontWeight="800"
                                    sx={{ padding: "10px 10px 0 10px" }}
                                >
                                    {salesPersonData.filter(item => item.get('status') === 'open').flatMap(data => data.get("sections")).reduce((total, section, index, array) => index === array.length - 1 ? (total + (parseFloat(section.marginPercentage) || 0)) / array.length : total + (parseFloat(section.marginPercentage) || 0), 0).toFixed(2)}%
                                </Typography>
                            </Box>
                            <Box display={"flex"} justifyContent={'space-between'}>
                                <Typography
                                    variant="h4"
                                    fontWeight="600"
                                    sx={{ padding: "10px 10px 0 10px" }}
                                    color={colors.greenAccent[400]}
                                >
                                    Average Discount% in Open Stage
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontWeight="800"
                                    sx={{ padding: "10px 10px 0 10px" }}
                                >
                                    {salesPersonData.filter(item => item.get('status') === 'open').flatMap(data => data.get("sections")).reduce((total, section, index, array) => index === array.length - 1 ? (total + (parseFloat(section.discountPercentage) || 0)) / array.length : total + (parseFloat(section.discountPercentage) || 0), 0).toFixed(2)}%
                                </Typography>
                            </Box>
                        </Box>

                        <Box display={"flex"} justifyContent={'space-between'} borderBottom={`1px solid ${colors.primary[600]}`} pb={1}>
                            <Box display={"flex"} justifyContent={'space-between'}>
                                <Typography
                                    variant="h4"
                                    fontWeight="600"
                                    sx={{ padding: "10px 10px 0 10px" }}
                                    color={colors.greenAccent[400]}
                                >
                                    Total Quotations in Deposit Stage
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontWeight="800"
                                    sx={{ padding: "10px 10px 0 10px" }}
                                >
                                    {depositCount}
                                </Typography>
                            </Box>

                            <Box display={"flex"} justifyContent={'space-between'}>
                                <Typography
                                    variant="h4"
                                    fontWeight="600"
                                    sx={{ padding: "10px 10px 0 10px" }}
                                    color={colors.greenAccent[400]}
                                >
                                    Total Deposit Stage Amount
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontWeight="800"
                                    sx={{ padding: "10px 10px 0 10px" }}
                                >
                                    ${formatCurrency(depositAmount.toFixed(2))}
                                </Typography>
                            </Box>
                        </Box>
                        <Box display={"flex"} justifyContent={'space-between'} borderBottom={`1px solid ${colors.primary[600]}`} pb={1}>
                            <Box display={"flex"} justifyContent={'space-between'}>
                                <Typography
                                    variant="h4"
                                    fontWeight="600"
                                    sx={{ padding: "10px 10px 0 10px" }}
                                    color={colors.greenAccent[400]}
                                >
                                    Average Margin% in Deposit Stage
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontWeight="800"
                                    sx={{ padding: "10px 10px 0 10px" }}
                                >
                                    {salesPersonData.filter(item => item.get('status') === 'deposit').flatMap(data => data.get("sections")).reduce((total, section, index, array) => index === array.length - 1 ? (total + (parseFloat(section.marginPercentage) || 0)) / array.length : total + (parseFloat(section.marginPercentage) || 0), 0).toFixed(2)}%
                                </Typography>
                            </Box>
                            <Box display={"flex"} justifyContent={'space-between'}>
                                <Typography
                                    variant="h4"
                                    fontWeight="600"
                                    sx={{ padding: "10px 10px 0 10px" }}
                                    color={colors.greenAccent[400]}
                                >
                                    Average Discount in Deposit Stage
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontWeight="800"
                                    sx={{ padding: "10px 10px 0 10px" }}
                                >
                                    {salesPersonData.filter(item => item.get('status') === 'deposit').flatMap(data => data.get("sections")).reduce((total, section, index, array) => index === array.length - 1 ? (total + (parseFloat(section.discountPercentage) || 0)) / array.length : total + (parseFloat(section.discountPercentage) || 0), 0).toFixed(2)}
                                </Typography>
                            </Box>
                        </Box>

                        <Box display={"flex"} justifyContent={'space-around'} border={`1px solid ${colors.redAccent[600]}`} borderRadius={2} p={1} mt={2}>
                            <Typography
                                variant="h4"
                                fontWeight="600"
                                sx={{ padding: "10px 10px 10 10px" }}
                                color={colors.redAccent[400]}
                            >
                                Win Rate
                            </Typography>
                            <Typography
                                variant="h4"
                                fontWeight="800"
                                sx={{ padding: "10px 10px 10 10px" }}
                            >
                                {((salesPersonData.reduce((count, item) => {
                                    let depositCount = item.get('status') === "deposit" ? 1 : 0;
                                    const revisions = item.get('fetchedRevisions') || [];
                                    depositCount += revisions.filter(rev => rev.get('status') === "deposit").length;
                                    return count + depositCount;
                                }, 0)) / (salesPersonData.length) * 100).toFixed(2)}%
                            </Typography>
                        </Box>

                    </AccordionDetails>
                </Accordion>
                <Box display={"flex"} mb={2}>
                    <Typography
                        variant="h4"
                        fontWeight="600"
                        sx={{ padding: "10px 10px 0 10px" }}
                        color={colors.greenAccent[400]}
                    >
                        Total Quotations Made:
                    </Typography>
                    <Typography
                        variant="h4"
                        fontWeight="800"
                        sx={{ padding: "10px 10px 0 10px" }}
                    >
                        {salesPersonData.length}
                    </Typography>
                </Box>
                <DataGridPro
                    sx={{
                        // disable cell selection style
                        ".MuiDataGrid-cell:focus": {
                            outline: "none"
                        },
                        // pointer cursor on ALL rows
                        "& .MuiDataGrid-row:hover": {
                            cursor: "pointer",
                        },
                        padding: 2,
                        boxShadow: 3,
                        border: 0,
                        borderColor: 'primary.light',
                        '& .MuiDataGrid-cell:hover': {
                            color: '#20c997',
                        },
                        fontSize: '18px'
                    }}
                    slotProps={{
                        filterPanel: {
                            sx: {
                                "& .MuiButtonBase-root": {
                                    backgroundColor: 'wheat'
                                }
                            }
                        }
                    }}
                    rows={salesPersonData}
                    columns={columns}
                    sortModel={sortModel}
                    onSortModelChange={(model) => setSortModel(model)}
                    onRowClick={handleQuotationItemDetailRouting}
                />
            </Paper>}
        </>
    )
}

export default SalesPersonReport;